const conditionTypes = {
    action: 0,
    arrival: 1
};

export {
    conditionTypes
};